import {createSlice} from "@reduxjs/toolkit";

const initialPasoCuatro = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    pasoCuatroAlCincoInformacion: undefined,
    pasoCuatroAlTresInformacion:undefined,
    lastError: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };

  export const pasoCuatroSlice=createSlice({
    name:"pasoCuatro",
    initialState:initialPasoCuatro,
    reducers:{
      catchErrorPasoCuatroAlCinco:(state,action)=>{
          state.error = action.payload.error.clientMessage;
          state.pasoCuatroAlCincoInformacion=undefined;
          if(action.payload.callType===callTypes.list){
              state.listLoading=false;
          }else{
              state.actionsLoading=false;
          };
      },
      catchErrorCuatroAlTres:(state,action)=>{
        state.error = action.payload.error.clientMessage;
        state.pasoCuatroAlTresInformacion=undefined;
        if(action.payload.callType===callTypes.list){
            state.listLoading=false;
        }else{
            state.actionsLoading=false;
        };
    },
      starCall:(state,action)=>{
          state.error=null;
          if(action.payload.callType===callTypes.list){
              state.listLoading=true;
          }else{
              state.actionsLoading=true;
          };
      },
      pasoCuatroAlCincoFetched:(state,action)=>{
          state.actionsLoading=false;
          state.pasoCuatroAlCincoInformacion=action.payload.pasoCuatroAlCincoInformacion;
          state.error=null;
      },
      pasoCuatroAlTresFetched:(state,action)=>{
        state.actionsLoading=false;
        state.pasoCuatroAlTresInformacion=action.payload.pasoCuatroAlTresInformacion;
        state.error=null;
    },
    stateLimpiar: (state, action) => {
        state.actionsLoading = false;
        state.entities= null;
        state.pasoCuatroAlCincoInformacion= undefined;
        state.pasoCuatroAlTresInformacion=undefined;
        state.error = null;
    },
    }
});